import { ValidatorList } from '../../validator/validatorList';
import { NotEmpty } from '../../validator/notEmpty';
import { MinLength } from '../../validator/minLength';
import { MaxLength } from '../../validator/maxLength';
import { NotSameValue } from '../../validator/notSameValue';
import { SameValue } from '../../validator/sameValue';
import { RegexValidator } from '../../validator/regexValidator';
export class DefaultText {
    constructor(element) {
        this.element = element;
    }
    getDefaultValidator() {
        const list = new ValidatorList();
        if (this.element.hasAttribute('required')) {
            list.add(new NotEmpty(this.element.name, this.element.value, this.element.requiredErrorMsg ? this.element.requiredErrorMsg : ''));
        }
        if (this.element.notSameValueName && this.element.notSameValue) {
            list.add(new NotSameValue(this.element.value, this.element.notSameValue, this.element.name, this.element.notSameValueName, this.element.notSameValueErrorMsg ? this.element.notSameValueErrorMsg : undefined));
        }
        if (this.element.name && this.element.name.includes('Repeat') && this.element.value) {
            list.add(new SameValue(this.element.value, this.element.repeatValue, this.element.name, this.element.repeatErrorMsg ? this.element.repeatErrorMsg : ''));
        }
        if (this.element.regExp && this.element.value) {
            if (typeof this.element.regExp === 'string') {
                this.element.regExp = new RegExp(this.element.regExp);
            }
            list.add(new RegexValidator(this.element.name, this.element.value, this.element.regExp, this.element.regExpErrorMsg ? this.element.regExpErrorMsg : undefined));
        }
        return list;
    }
    getValidator() {
        const list = this.getDefaultValidator();
        if ((this.element.hasAttribute('required') || this.element.value) && this.element.hasAttribute('minLength')) {
            list.add(new MinLength(this.element.name, this.element.value, Number(this.element.minLength), this.element.minLengthErrorMsg ? this.element.minLengthErrorMsg : undefined));
        }
        if ((this.element.hasAttribute('required') || this.element.value) && this.element.hasAttribute('maxLength')) {
            list.add(new MaxLength(this.element.name, this.element.value, Number(this.element.maxLength), this.element.maxLengthErrorMsg ? this.element.maxLengthErrorMsg : undefined));
        }
        return list;
    }
}
//# sourceMappingURL=defaultText.js.map